export const BaseUrl = (cat, startDate, endDate) => {
  const { REACT_APP_STAGE } = process.env;

  return REACT_APP_STAGE === "production"
    ? `https://ttzf8v3ol6.execute-api.us-west-2.amazonaws.com/prod/querytables?table=${cat}&fromDate=${startDate}&toDate=${endDate}`
    : `https://q9qp0qlm4l.execute-api.us-west-2.amazonaws.com/prod/querytables?table=${cat}&fromDate=${startDate}&toDate=${endDate}`;
};
